import styled from 'styled-components';

export const StyledFaqList = styled.ul`
    margin: 0;
    padding-left: 0;
    list-style-type: none;
`;

export const StyledFaqListItem = styled.li`
    margin-bottom: ${({ theme }) => theme.spacing.md};

    &:last-of-type {
        margin-bottom: 0;
    }
`;
